/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popNftTask.vue?vue&type=template&id=9a65cb1a&scoped=true"
import script from "./popNftTask.vue?vue&type=script&lang=js"
export * from "./popNftTask.vue?vue&type=script&lang=js"
import style0 from "./popNftTask.vue?vue&type=style&index=0&id=9a65cb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a65cb1a",
  null
  
)

export default component.exports